import { TFunction } from 'i18next';

const incomeIntervalOptions = (t: TFunction) => [
  { value: 'YEARLY', label: t('Yearly') },
  { value: 'MONTHLY', label: t('Monthly') },
  { value: 'WEEKLY', label: t('Weekly') }
];

export default incomeIntervalOptions;
